// External dependencies
import { CloseOutlined, RightOutlined } from "@ant-design/icons";
import { Alert, Button } from "antd";
import { Modal } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";

// Types and interfaces
import { newFormInpPropType } from "../../@types/user";
import { RootState } from "../../redux/store";

// Redux and state management
import { 
  popupInputChange, 
  popupInputVerify 
} from "../../redux/calculatorSlice";

// Components
import HintGuide from "../guide/HintGuide";
import InputBox from "../input";
import Question from "../../svg/question";

interface PopupDataItem {
  name: string;
  value?: string;
  percent?: boolean;
}


const Popup: React.FC<newFormInpPropType> = ({
  activeIndex,
  index,
  data,
  outerIndex,
  currency
}) => {
  const version = useSelector((state: RootState) => 
    state.calculator.tabs[state.calculator.activeTab].version
  );

  const [showPopup, setPopUp] = useState<boolean>(false);
  const [showMsg, setShowMsg] = useState<boolean>(false);
  const [pass, setPass] = useState<boolean>(false);
  
  const msgCnt = useRef<HTMLDivElement>(null);
  const msgRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const handleWindowClick = (e: MouseEvent) => {
      if (msgCnt.current && msgRef.current) {
        if (!msgCnt.current.contains(e.target as Node) && !msgRef.current.contains(e.target as Node)) {
          setShowMsg(false);
        }
      }
    };

    window.addEventListener('click', handleWindowClick);
    return () => window.removeEventListener('click', handleWindowClick);
  }, []);

  useEffect(() => {
    checkPass();
  }, [data?.data]);

  const checkPass = () => {
    const filledCount = data?.data?.filter(element => element.value).length || 0;
    const totalCount = data?.data?.length || 0;
    setPass(filledCount === totalCount);
  };

  const handleVerify = () => {
    if (data?.required) {
      const hasError = data.data?.some(element => !element.value);
      setPass(!hasError);

      dispatch(popupInputVerify({
        value: JSON.stringify({ error: hasError }),
        outerIndex,
        innerIndex: index
      }));
    } else {
      dispatch(popupInputVerify({
        value: JSON.stringify({ error: false }),
        outerIndex,
        innerIndex: index
      }));
      
      checkPass();
    }

    setPopUp(false);
  };

  const handleInputChange = (value: string, nestIndex: number) => {
    dispatch(popupInputChange({
      value: JSON.stringify({ data: value, nestInd: nestIndex }),
      outerIndex,
      innerIndex: index
    }));
  };

  const renderMessage = () => {
    if (!showMsg) return null;

    const versionNumber = parseInt(version?.replaceAll("v", "") || "0", 10);

    if (versionNumber > 10) {
      return (
        <HintGuide
          onClose={() => setShowMsg(false)}
          targetElem={msgRef?.current}
          heading={data?.name}
          msg={data?.msg}
        />
      );
    }

    return (
      <div className="formMsg" ref={msgCnt}>
         {versionNumber >= 3 ? (
            Array.isArray(data?.msg) && data?.msg.map((elem, idx) => (
                <p key={`msg${idx}`}>{elem}</p>
            ))
        ) : (
          <p>{data?.msg}</p>
        )}
      </div>
    );
  };

  return (
    <>
      <Modal
        className="modal"
        open={showPopup}
        onClose={handleVerify}
      >
        <div className="modalPopUp">
          <CloseOutlined
            className="popupClose"
            onClick={() => setPopUp(false)}
          />
          <div className="mpuTop">
            <div>
              {data?.data?.map((item, index) => (
                <InputBox
                  key={`input-${index}`}
                  type="Cnumber"
                  placeholder={item.name}
                  value={item.value}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => 
                    handleInputChange(e.target.value, index)
                  }
                  percent={item.percent}
                />
              ))}
            </div>
          </div>

          <div className="mpuBot">
            <Button className="mybtn-blue" type="text" onClick={handleVerify}>
              Done <RightOutlined />
            </Button>
          </div>
        </div>
      </Modal>

      <div className="formMainCnt">
        <p className="formTitle">{data?.name}</p>
        <div
          className={`
            formInputCnt 
            ${data?.error ? "doublePopupempty" : ""} 
            ${pass ? "doublePopupfilled" : ""}
          `}
        >
          <div
            className="mainInput myselect"
            style={{
              height: "100%",
              flex: "1",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              color: "gray"
            }}
            onClick={() => setPopUp(true)}
          >
            Click to edit
          </div>

          <Question
            className="formQuestion"
            onClick={() => setShowMsg(true)}
            myRef={msgRef}
            error={data?.error || false}
          />
        </div>

        {data?.error && (
          <Alert
            style={{ fontSize: "12px", padding: "5px 10px" }}
            description="One or more sub-fields are Empty!"
            type="error"
            showIcon={false}
          />
        )}
        {renderMessage()}
      </div>
    </>
  );
};

export default Popup;